import React, { useState } from "react";
import {
  Box,
  Grid,
    Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
    Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  ButtonBase,
  IconButton,
  Collapse

} from "@mui/material";
import Stack from '@mui/material/Stack';

import { People, Home } from "@mui/icons-material";
import ElderlyRoundedIcon from "@mui/icons-material/ElderlyRounded";
import FmdBadRoundedIcon from "@mui/icons-material/FmdBadRounded";
import TranslateRoundedIcon from "@mui/icons-material/TranslateRounded";
import { green, red, blue, purple, grey, amber } from '@mui/material/colors';



const KeyAreaStats = ({
    extDataBlurb,
 extDataBlurbComparison,
 selectedFeature,
 selectedAreaId,
 hoverArea,
 selectedFeatureLevel,
 selectedconstName,

}) => {
  const isWard = selectedFeatureLevel === "ward";
  const showComparison = isWard && extDataBlurbComparison;
  const comparisonLabel = selectedconstName || "Constituency";
    // At ward level use the selected ward; otherwise use hover (constituency view)
    const activeAreaId = selectedFeatureLevel === "ward" && selectedAreaId
      ? selectedAreaId
      : hoverArea;
    const filtered = (extDataBlurb || []).filter(item => item.area_id === activeAreaId);
      // If selectedFeature exists, override comparisonData with a hardcoded value
  const comparisonData = selectedFeature 
    ? extDataBlurbComparison
    :[
        {
          area_id: "National",
          area_name: "National",
          deprived_share: 0.524,
          english_share: 0.982,
          homeowners_share: 0.616,
          over_50: 0.478,
          pv_con: 0.237,
          pv_green: 0.063,
          pv_lab: 0.337,
          pv_libdem: 0.122,
          pv_other: 0.065,
          pv_pc: 0.0068,
          pv_reform: 0.142,
          pv_snp: 0.025,
          white_share: 0.829,
        },
      ];
  const R = 16;         // card radius (px)

  const demogs_name_bold = filtered[0]?.area_name ||  toTitleCase(selectedFeature?.name) || "National"
  const demogs_name_lower = isWard && selectedconstName
    ? selectedconstName
    : selectedFeature?.name ? toTitleCase(selectedFeature.name) : "National"
function toTitleCase(str) {
  if (!str || typeof str !== "string") return "";
  return str
    .toLowerCase()
    .split(" ")
    .filter(word => word.trim().length > 0)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}


  return (
      <> 
    
   
  {/* Tab buttons at top */}
  <Box
    sx={{
      display: "flex",
      borderTopLeftRadius: `${R}px`,
      borderTopRightRadius: `${R}px`,
    }}
  >
{
       (filtered ) &&
       (comparisonData )  &&(
            filtered && filtered.length > 0 && comparisonData   ?(
                <>

                    <Grid container spacing={1} sx={{alignItems: "center", display: "flex",justifyContent: "center"}}>

                     <Typography variant="body1" sx={{}} width="100%">
                        <span><b>{demogs_name_bold}</b></span> <span>({demogs_name_lower})</span>
                         </Typography>

                

                    <Grid size={4} sx={{alignItems: "center", display: "flex",justifyContent: "center"}}>
                        <Stack sx={{alignItems: "center", display: "flex",justifyContent: "center"}}>
                        <Box
                            sx={{
                                color: purple[500],
                                display: "flex",
                                alignItems: "center",
                                
                            }}
                            >
                            {<ElderlyRoundedIcon/>}
                            </Box>
                            <Typography variant="body2" sx={{ fontSize: "0.8rem" }}>
                            Over 50:
                            </Typography>
                           {/* Median Age */}
                        <Typography variant="body2" sx={{ fontSize: "0.9rem",
                        color:
                            (filtered[0]?.over_50 != null && comparisonData?.[0]?.over_50 != null &&
                            Number(filtered[0].over_50.toFixed(2)) > Number(comparisonData[0].over_50.toFixed(2)))
                            ? green[500]
                            : red[500]
                        }}>
                        <span><b>{filtered[0]?.over_50 != null ? (Number(filtered[0].over_50)*100).toFixed(0) +" %" : "—"}</b></span>
                        </Typography>
                        <Typography variant="body2" sx={{ fontSize: "0.8rem" }}>
                        <span>({comparisonData?.[0]?.over_50 != null ? (Number(comparisonData[0].over_50)*100).toFixed(0) +" %" : "—"})</span>
                        </Typography>

                            
                        </Stack>
                    </Grid>
                    <Grid size={4} sx={{alignItems: "center", display: "flex",justifyContent: "center"}}>
                    <Stack sx={{alignItems: "center", display: "flex",justifyContent: "center"}}>
                        <Box
                            sx={{
                                color: green[500],
                                display: "flex",
                                alignItems: "center",
                                
                            }}
                            >
                            {<FmdBadRoundedIcon/>}
                            </Box>
                            <Typography variant="body2" sx={{ fontSize: "0.8rem" }}>
                            Facing deprivation:
                           </Typography>
                           {/* Median Age */}
                        <Typography variant="body2" sx={{ fontSize: "0.9rem",
                        color:
                            (filtered[0]?.deprived_share != null && comparisonData?.[0]?.deprived_share != null &&
                            Number(filtered[0].deprived_share.toFixed(2)) > Number(comparisonData[0].deprived_share.toFixed(2)))
                            ? green[500]
                            : red[500]
                        }}>
                        <span><b>{filtered[0]?.deprived_share != null ? <span> {(Number(filtered[0].deprived_share)*100).toFixed(0)+ " %"}  </span>  : "—"}</b></span>
                        </Typography>
                        <Typography variant="body2" sx={{ fontSize: "0.8rem" }}>
                        <span>({comparisonData?.[0]?.deprived_share != null ?<span>{(Number(comparisonData[0].deprived_share)*100).toFixed(0)+ " %"}</span>  : "—"})</span>
                        </Typography>

                        </Stack>
                    </Grid>
                    <Grid size={4} sx={{alignItems: "center", display: "flex",justifyContent: "center", alignContent: "center"}}>
                        <Stack sx={{alignItems: "center", display: "flex",justifyContent: "center", alignContent: "center"}}>
                        <Box
                            sx={{
                                color: blue[500],
                                display: "flex",
                                alignItems: "center",
                              
                            }}
                            >
                            {<People/>}
                            </Box>
                            <Typography variant="body2" sx={{ fontSize: "0.8rem" ,alignItems: "center", display: "flex",justifyContent: "center", textAlign: "center"}}>
                            White:
                            </Typography>
                            <Typography variant="body2" sx={{ fontSize: "0.9rem",
                            color:
                                (filtered[0]?.white_share != null && comparisonData?.[0]?.white_share != null &&
                                Number(filtered[0].white_share.toFixed(2)) > Number(comparisonData[0].white_share.toFixed(2)))
                                ? green[500]
                                : red[500]
                            }}>
                            <b>{filtered[0]?.white_share != null ? (Number(filtered[0].white_share) * 100).toFixed(0) + "%" : "—"}</b>
                            </Typography>
                            <Typography variant="body2" sx={{ fontSize: "0.8rem" }}>
                            ({comparisonData?.[0]?.white_share != null ? (Number(comparisonData[0].white_share) * 100).toFixed(0) + "%" : "—"})
                            </Typography>
                            
                        </Stack>
                    </Grid>
                    <Grid size={4} sx={{alignItems: "center", display: "flex",justifyContent: "center"}}>
                            <Stack sx={{alignItems: "center", display: "flex",justifyContent: "center", alignContent: "center"}}>
                            <Box
                            sx={{
                                color: grey[500],
                                display: "flex",
                                alignItems: "center",
                              
                            }}
                            >
                            {<Home/>}
                            </Box>
                            <Typography variant="body2" sx={{ fontSize: "0.8rem" ,alignItems: "center", display: "flex",justifyContent: "center", textAlign: "center"}}>
                            Own home:
                            </Typography>
                            <Typography variant="body2" sx={{ fontSize: "0.9rem",
                            color:
                                (filtered[0]?.homeowners_share != null && comparisonData?.[0]?.homeowners_share != null &&
                                Number(filtered[0].homeowners_share.toFixed(2)) > Number(comparisonData[0].homeowners_share.toFixed(2)))
                                ? green[500]
                                : red[500]
                            }}>
                            <b>{filtered[0]?.homeowners_share != null ?(Number(filtered[0].homeowners_share) * 100).toFixed(0) + "%": "—"}</b>
                            </Typography>
                            <Typography variant="body2" sx={{ fontSize: "0.8rem" }}>
                            ({comparisonData?.[0]?.homeowners_share != null ?(Number(comparisonData[0].homeowners_share) * 100).toFixed(0) + "%": "—"})
                            </Typography>
                            
                        </Stack>
                    </Grid>
                    <Grid size={4} sx={{alignItems: "center", display: "flex",justifyContent: "center"}}>
                            <Stack sx={{alignItems: "center", display: "flex",justifyContent: "center", alignContent: "center"}}>
                                <Box
                            sx={{
                                color: amber[500],
                                display: "flex",
                                alignItems: "center",
                              
                            }}
                            >
                            {<TranslateRoundedIcon/>}
                            </Box>
                            <Typography variant="body2" sx={{ fontSize: "0.8rem" ,alignItems: "center", display: "flex",justifyContent: "center", textAlign: "center"}}>
                            Speak English well:
                            </Typography>
                            <Typography variant="body2" sx={{ fontSize: "0.9rem",
                            color:
                                (filtered[0]?.english_share != null && comparisonData?.[0]?.english_share != null &&
                                Number(filtered[0].english_share.toFixed(2)) > Number(comparisonData[0].english_share.toFixed(2)))
                                ? green[500]
                                : red[500]
                            }}>
                            <b>{filtered[0]?.english_share != null ?(Number(filtered[0].english_share) * 100).toFixed(0) + "%" : "—"}</b>
                            </Typography>
                            <Typography variant="body2" sx={{ fontSize: "0.8rem" }}>
                            ({comparisonData?.[0]?.english_share != null ?(Number(comparisonData[0].english_share) * 100).toFixed(0) + "%": "—"})
                            </Typography>

                            
                        </Stack>
                    </Grid>
                    <Typography variant="body2" sx={{ }} width="100%">
                        2024 vote:
                         </Typography>

                     <TableContainer sx={{}} >
                    <Table sx={{ width: "100%", tableLayout: "fixed" }}>
                        {/* Table Head */}
                        <TableHead >
                        <TableRow sx={{ height: 20 }}>
                            <TableCell padding="none" sx={{ fontSize: "0.7rem",verticalAlign: "middle", textAlign: "center"}}>Labour</TableCell>
                            <TableCell padding="none" sx={{ fontSize: "0.7rem",verticalAlign: "middle", textAlign: "center"}}>Conservatives</TableCell>
                            <TableCell padding="none" sx={{ fontSize: "0.7rem",verticalAlign: "middle", textAlign: "center"}}>Liberal Democrats</TableCell>
                            <TableCell padding="none" sx={{ fontSize: "0.7rem",verticalAlign: "middle", textAlign: "center"}}>Reform</TableCell>
                            <TableCell padding="none" sx={{ fontSize: "0.7rem",verticalAlign: "middle", textAlign: "center"}}>Green</TableCell>
                            {Number(filtered[0]?.pv_snp) > 0 && (<TableCell padding="none" sx={{ fontSize: "0.7rem",verticalAlign: "middle", textAlign: "center"}}>SNP</TableCell>)}
                             {Number(filtered[0]?.pv_pc) > 0 && (<TableCell padding="none" sx={{ fontSize: "0.7rem",verticalAlign: "middle", textAlign: "center"}}>Plaid Cymru</TableCell>)}
                            {/* <TableCell padding="none" sx={{ fontSize: "0.7rem",verticalAlign: "middle", textAlign: "center"}}>Other</TableCell> */}
                        </TableRow>
                        </TableHead>

                        {/* Table Body */}
                        <TableBody>
                        
                        <TableRow>
                        <TableCell  padding="none" sx={{ fontSize: "0.8rem", fontWeight: "bold",verticalAlign: "middle", textAlign: "center", color :"#d50000"}}>{(Number(filtered[0].pv_lab)*100).toFixed(0)}%</TableCell>
                        <TableCell  padding="none" sx={{ fontSize: "0.8rem", fontWeight: "bold",verticalAlign: "middle", textAlign: "center",color:"#0087dc" }}>{(Number(filtered[0].pv_con)*100).toFixed(0)}%</TableCell>
                        <TableCell  padding="none" sx={{ fontSize: "0.8rem", fontWeight: "bold",verticalAlign: "middle", textAlign: "center",color:"#FDBB30"}}>{(Number(filtered[0].pv_libdem)*100).toFixed(0)}%</TableCell>
                        <TableCell  padding="none" sx={{ fontSize: "0.8rem", fontWeight: "bold",verticalAlign: "middle", textAlign: "center",color:"#12B6CF"}}>{(Number(filtered[0].pv_reform)*100).toFixed(0)}%</TableCell>
                        <TableCell  padding="none" sx={{ fontSize: "0.8rem", fontWeight: "bold",verticalAlign: "middle", textAlign: "center",color:"#008066"}}>{(Number(filtered[0].pv_green)*100).toFixed(0)}%</TableCell>
                        {Number(filtered[0]?.pv_snp) > 0 && (<TableCell  padding="none" sx={{ fontSize: "0.8rem", fontWeight: "bold",verticalAlign: "middle", textAlign: "center",color:"#0A2C50"}}>{(Number(filtered[0]?.pv_snp)*100).toFixed(0)}%</TableCell>)}
                        {Number(filtered[0]?.pv_pc) > 0 && (<TableCell  padding="none" sx={{ fontSize: "0.8rem", fontWeight: "bold",verticalAlign: "middle", textAlign: "center",color:"#3F8428"}}>{(Number(filtered[0]?.pv_pc)*100).toFixed(0)}%</TableCell>)}
                        {/* <TableCell  padding="none" sx={{ fontSize: "0.8rem", fontWeight: "bold",verticalAlign: "middle", textAlign: "center"}}>{(Number(filtered[0].pv_other)*100).toFixed(0)}%</TableCell> */}
                        </TableRow>
                        <TableRow>
                        <TableCell  padding="none" sx={{ fontSize: "0.8rem", verticalAlign: "middle", textAlign: "center", color :"#d50000"}}>{(Number(comparisonData ?comparisonData[0]?.pv_lab:null)*100).toFixed(0)}%</TableCell>
                        <TableCell  padding="none" sx={{ fontSize: "0.8rem", verticalAlign: "middle", textAlign: "center",color:"#0087dc" }}>{(Number(comparisonData ?comparisonData[0]?.pv_con:null)*100).toFixed(0)}%</TableCell>
                        <TableCell  padding="none" sx={{ fontSize: "0.8rem", fverticalAlign: "middle", textAlign: "center",color:"#FDBB30"}}>{(Number(comparisonData ?comparisonData[0]?.pv_libdem:null)*100).toFixed(0)}%</TableCell>
                        <TableCell  padding="none" sx={{ fontSize: "0.8rem", verticalAlign: "middle", textAlign: "center",color:"#12B6CF"}}>{(Number(comparisonData ?comparisonData[0]?.pv_reform:null)*100).toFixed(0)}%</TableCell>
                        <TableCell  padding="none" sx={{ fontSize: "0.8rem", verticalAlign: "middle", textAlign: "center",color:"#008066"}}>{(Number(comparisonData ?comparisonData[0]?.pv_green:null)*100).toFixed(0)}%</TableCell>
                        {Number(filtered[0]?.pv_snp) > 0 && (<TableCell  padding="none" sx={{ fontSize: "0.8rem", verticalAlign: "middle", textAlign: "center",color:"#0A2C50"}}>{(Number(comparisonData ?comparisonData[0]?.pv_snp:null)*100).toFixed(0)}%</TableCell>)}
                       {Number(filtered[0]?.pv_pc) > 0 && ( <TableCell  padding="none" sx={{ fontSize: "0.8rem", verticalAlign: "middle", textAlign: "center",color:"#3F8428"}}>{(Number(comparisonData ?comparisonData[0]?.pv_pc:null)*100).toFixed(0)}%</TableCell>)}
                        {/* <TableCell  padding="none" sx={{ fontSize: "0.8rem", verticalAlign: "middle", textAlign: "center"}}>{(Number(comparisonData ?comparisonData[0]?.pv_other:null)*100).toFixed(0)}%</TableCell> */}
                        </TableRow>
                        </TableBody>
                    </Table>
                    </TableContainer>
                    </Grid>
                    </>
            ): filtered && filtered.length ===0 && comparisonData  ?(
                  <>
                    <Grid container spacing={2} sx={{alignItems: "center", display: "flex",justifyContent: "center"}}>
                     <Typography variant="body1" sx={{ mb: 0.75}} width="100%">
                        <span><b>{demogs_name_bold}</b></span> 
                         </Typography>

                


                    <Grid size={4} sx={{alignItems: "center", display: "flex",justifyContent: "center"}}>
                        <Stack sx={{alignItems: "center", display: "flex",justifyContent: "center"}}>
                        <Box
                            sx={{
                                color: purple[500],
                                display: "flex",
                                alignItems: "center",
                                
                            }}
                            >
                            {<ElderlyRoundedIcon/>}
                            </Box>
                            <Typography variant="body2" sx={{ fontSize: "0.8rem" }}>
                            Over 50:
                            </Typography>
                            <Typography variant="body2" sx={{ fontSize: "0.9rem" }}>
                            <span><b>{(Number(comparisonData ?comparisonData[0]?.over_50:null)*100).toFixed(0)+" %"}</b></span>
                            </Typography>
                            
                        </Stack>
                    </Grid>
                    <Grid size={4} sx={{alignItems: "center", display: "flex",justifyContent: "center"}}>
                    <Stack sx={{alignItems: "center", display: "flex",justifyContent: "center"}}>
                        <Box
                            sx={{
                                color: green[500],
                                display: "flex",
                                alignItems: "center",
                                
                            }}
                            >
                            {<FmdBadRoundedIcon/>}
                            </Box>
                            <Typography variant="body2" sx={{ fontSize: "0.8rem" }}>
                            Facing deprivation:
                            </Typography>
                            <Typography variant="body2" sx={{ fontSize: "0.9rem" }}>
                            <span><b>{(Number(comparisonData ?comparisonData[0]?.deprived_share:null)*100).toFixed(0)+ " %"}</b></span>
                            </Typography>
                            
                        </Stack>
                    </Grid>
                    <Grid size={4} sx={{alignItems: "center", display: "flex",justifyContent: "center", alignContent: "center"}}>
                        <Stack sx={{alignItems: "center", display: "flex",justifyContent: "center", alignContent: "center"}}>
                        <Box
                            sx={{
                                color: blue[500],
                                display: "flex",
                                alignItems: "center",
                              
                            }}
                            >
                            {<People/>}
                            </Box>
                            <Typography variant="body2" sx={{ fontSize: "0.8rem" ,alignItems: "center", display: "flex",justifyContent: "center", textAlign: "center"}}>
                            White:
                            </Typography>
                            <Typography variant="body2" sx={{ fontSize: "0.9rem" }}>
                            <span><b>{(Number(comparisonData ?comparisonData[0]?.white_share:null)*100).toFixed(0)}%</b></span>
                            </Typography>
                            
                        </Stack>
                    </Grid>
                    <Grid size={4} sx={{alignItems: "center", display: "flex",justifyContent: "center"}}>
                            <Stack sx={{alignItems: "center", display: "flex",justifyContent: "center", alignContent: "center"}}>
                            <Box
                            sx={{
                                color: grey[500],
                                display: "flex",
                                alignItems: "center",
                              
                            }}
                            >
                            {<Home/>}
                            </Box>
                            <Typography variant="body2" sx={{ fontSize: "0.8rem" ,alignItems: "center", display: "flex",justifyContent: "center", textAlign: "center"}}>
                            Own home:
                            </Typography>
                            <Typography variant="body2" sx={{ fontSize: "0.9rem" }}>
                            <span><b>{(Number(comparisonData ?comparisonData[0]?.homeowners_share:null)*100).toFixed(0)}%</b></span>
                            </Typography>
                            
                        </Stack>
                    </Grid>
                    <Grid size={4} sx={{alignItems: "center", display: "flex",justifyContent: "center"}}>
                            <Stack sx={{alignItems: "center", display: "flex",justifyContent: "center", alignContent: "center"}}>
                                <Box
                            sx={{
                                color: amber[500],
                                display: "flex",
                                alignItems: "center",
                              
                            }}
                            >
                            {<TranslateRoundedIcon/>}
                            </Box>
                            <Typography variant="body2" sx={{ fontSize: "0.8rem" ,alignItems: "center", display: "flex",justifyContent: "center", textAlign: "center"}}>
                            Speak English Well:
                            </Typography>
                            <Typography variant="body2" sx={{ fontSize: "0.9rem" }}>
                            <span><b>{(Number(comparisonData ?comparisonData[0]?.english_share:null)*100).toFixed(0)}%</b></span>
                            </Typography>
                            
                        </Stack>
                    </Grid>
                    <Typography variant="body2" sx={{ mt:2}} width="100%">
                        2024 vote:
                         </Typography>

                     <TableContainer sx={{ mb:1}} >
                    <Table sx={{ width: "100%", tableLayout: "fixed" }}>
                        {/* Table Head */}
                        <TableHead >
                        <TableRow sx={{ height: 20 }}>
                            <TableCell padding="none" sx={{ fontSize: "0.7rem",verticalAlign: "middle", textAlign: "center"}}>Labour</TableCell>
                            <TableCell padding="none" sx={{ fontSize: "0.7rem",verticalAlign: "middle", textAlign: "center"}}>Conservatives</TableCell>
                            <TableCell padding="none" sx={{ fontSize: "0.7rem",verticalAlign: "middle", textAlign: "center"}}>Liberal Democrats</TableCell>
                            <TableCell padding="none" sx={{ fontSize: "0.7rem",verticalAlign: "middle", textAlign: "center"}}>Reform</TableCell>
                            <TableCell padding="none" sx={{ fontSize: "0.7rem",verticalAlign: "middle", textAlign: "center"}}>Green</TableCell>
                            {Number(filtered[0]?.pv_snp) > 0 && ( <TableCell padding="none" sx={{ fontSize: "0.7rem",verticalAlign: "middle", textAlign: "center"}}>SNP</TableCell>)}
                            {Number(filtered[0]?.pv_pc) > 0 && ( <TableCell padding="none" sx={{ fontSize: "0.7rem",verticalAlign: "middle", textAlign: "center"}}>Plaid Cymru</TableCell>)}
                            {/* <TableCell padding="none" sx={{ fontSize: "0.7rem",verticalAlign: "middle", textAlign: "center"}}>Other</TableCell> */}
                        </TableRow>
                        </TableHead>

                        {/* Table Body */}
                        <TableBody>
                        
                        <TableRow>
                        <TableCell  padding="none" sx={{ fontSize: "0.8rem", fontWeight: "bold",verticalAlign: "middle", textAlign: "center", color :"#d50000"}}>{(Number(comparisonData ?comparisonData[0]?.pv_lab:null)*100).toFixed(0)}%</TableCell>
                        <TableCell  padding="none" sx={{ fontSize: "0.8rem", fontWeight: "bold",verticalAlign: "middle", textAlign: "center",color:"#0087dc" }}>{(Number(comparisonData ?comparisonData[0]?.pv_con:null)*100).toFixed(0)}%</TableCell>
                        <TableCell  padding="none" sx={{ fontSize: "0.8rem", fontWeight: "bold",verticalAlign: "middle", textAlign: "center",color:"#FDBB30"}}>{(Number(comparisonData ?comparisonData[0]?.pv_libdem:null)*100).toFixed(0)}%</TableCell>
                        <TableCell  padding="none" sx={{ fontSize: "0.8rem", fontWeight: "bold",verticalAlign: "middle", textAlign: "center",color:"#12B6CF"}}>{(Number(comparisonData ?comparisonData[0]?.pv_reform:null)*100).toFixed(0)}%</TableCell>
                        <TableCell  padding="none" sx={{ fontSize: "0.8rem", fontWeight: "bold",verticalAlign: "middle", textAlign: "center",color:"#008066"}}>{(Number(comparisonData ?comparisonData[0]?.pv_green:null)*100).toFixed(0)}%</TableCell>
                         {Number(filtered[0]?.pv_snp) > 0 && (<TableCell  padding="none" sx={{ fontSize: "0.8rem", fontWeight: "bold",verticalAlign: "middle", textAlign: "center",color:"#0A2C50"}}>{(Number(comparisonData ?comparisonData[0]?.pv_snp:null)*100).toFixed(0)}%</TableCell>)}
                         {Number(filtered[0]?.pv_pc) > 0 && (<TableCell  padding="none" sx={{ fontSize: "0.8rem", fontWeight: "bold",verticalAlign: "middle", textAlign: "center",color:"#3F8428"}}>{(Number(comparisonData ?comparisonData[0]?.pv_pc:null)*100).toFixed(0)}%</TableCell>)}
                        {/* <TableCell  padding="none" sx={{ fontSize: "0.8rem", fontWeight: "bold",verticalAlign: "middle", textAlign: "center"}}>{(Number(comparisonData ?comparisonData[0]?.pv_other:null)*100).toFixed(0)}%</TableCell> */}
                        </TableRow>
                        </TableBody>
                    </Table>
                    </TableContainer>
                    </Grid>

                    </>
            ) : (
                         <Typography variant="body1" sx={{ mb: 0.75}}>
                            Loading </Typography>

            )
        )
        }
              </Box>

      {/* Bottom tab row */}




    </>
  )}

  
export default KeyAreaStats;